export default __webpack_public_path__ + "static/media/001.0f903e63.svg";